import { Input } from "@web-app/components";
import { AppFilterType, DutyStatus } from "@web-app/types";
import { OrderStatus } from "@web-app/types";

import { TabPanelWrapper } from "./TabPanelWrapper";

export default function StatusFilterTab({
  onChangeDriverStatus,
  onChangeOrderStatus,
  temporaryAppFilter,
}: {
  onChangeDriverStatus: (value: string, status: DutyStatus) => void;
  onChangeOrderStatus: (value: string, status: OrderStatus) => void;
  temporaryAppFilter: AppFilterType;
}) {
  return (
    <TabPanelWrapper>
      <div className="text-xs lg:text-sm font-semibold mt-2">Order Status</div>
      <div className="mb-4 md:mb-6 lg:mb-8 mt-1 md:mt-2 flex flex-col gap-1">
        <Input
          type="checkbox"
          value={
            temporaryAppFilter.orderStatus.includes(OrderStatus.TODO)
              ? "true"
              : "false"
          }
          rightLabel="Unassigned"
          onChange={(value) => onChangeOrderStatus(value, OrderStatus.TODO)}
        />
        <Input
          type="checkbox"
          value={
            temporaryAppFilter.orderStatus.includes(OrderStatus.ASSIGNED)
              ? "true"
              : "false"
          }
          rightLabel="Assigned"
          onChange={(value) => onChangeOrderStatus(value, OrderStatus.ASSIGNED)}
        />
        <Input
          type="checkbox"
          value={
            temporaryAppFilter.orderStatus.includes(OrderStatus.INPROGRESS)
              ? "true"
              : "false"
          }
          rightLabel="In Transit"
          onChange={(value) =>
            onChangeOrderStatus(value, OrderStatus.INPROGRESS)
          }
        />
        <Input
          type="checkbox"
          rightLabel="Completed"
          value={
            temporaryAppFilter.orderStatus.includes(OrderStatus.COMPLETE)
              ? "true"
              : "false"
          }
          onChange={(value) => onChangeOrderStatus(value, OrderStatus.COMPLETE)}
        />
        <Input
          type="checkbox"
          rightLabel="Failed"
          value={
            temporaryAppFilter.orderStatus.includes(OrderStatus.FAILED)
              ? "true"
              : "false"
          }
          onChange={(value) => onChangeOrderStatus(value, OrderStatus.FAILED)}
        />
        <Input
          type="checkbox"
          rightLabel="Cancelled"
          value={
            temporaryAppFilter.orderStatus.includes(OrderStatus.CANCELLED)
              ? "true"
              : "false"
          }
          onChange={(value) =>
            onChangeOrderStatus(value, OrderStatus.CANCELLED)
          }
        />
      </div>
      <div className="text-xs lg:text-sm font-semibold">Driver Status</div>
      <div className="mt-1 md:mt-2 flex flex-col gap-1 mb-2 md:mb-4 lg:mb-6">
        <Input
          type="checkbox"
          rightLabel="Online"
          value={
            temporaryAppFilter.driverStatus.includes(DutyStatus.ONLINE)
              ? "true"
              : "false"
          }
          onChange={(value) => onChangeDriverStatus(value, DutyStatus.ONLINE)}
        />
        <Input
          type="checkbox"
          rightLabel="Offline"
          value={
            temporaryAppFilter.driverStatus.includes(DutyStatus.OFFLINE)
              ? "true"
              : "false"
          }
          onChange={(value) => onChangeDriverStatus(value, DutyStatus.OFFLINE)}
        />
        <Input
          type="checkbox"
          rightLabel="In Transit"
          value={
            temporaryAppFilter.driverStatus.includes(DutyStatus.INTRANSIT)
              ? "true"
              : "false"
          }
          onChange={(value) =>
            onChangeDriverStatus(value, DutyStatus.INTRANSIT)
          }
        />
      </div>
    </TabPanelWrapper>
  );
}
